import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';
import Modal from '@xo-union/tk-component-modals';
import Icon from '@xo-union/tk-component-icons';
import AnalyticsStore from '~/glm/models/analytics-store';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import { H4, Body1, Caption } from '@xo-union/tk-ui-typography';
import GdsApi from '~/glm/utils/gds-api';
import styles from './export-modal.scss';

const fileNameOptions = {
  addresslabel: 'My Address Labels.csv',
  rsvp: 'My Rsvp List.csv',
  people: 'My Guest List.csv',
};

const DownloadButton = ({ onClick }) => (
  <div className={styles.download} onClick={onClick}>
    <Icon name="download" size="md" />
    <Body1>Download</Body1>
  </div>
);

DownloadButton.propTypes = {
  onClick: PropTypes.func,
};

@inject('gdsUiState', 'analyticsStore')
@observer
class ExportGuestListModal extends Component {
  static propTypes = {
    gdsUiState: PropTypes.instanceOf(GdsUiState).isRequired,
    analyticsStore: PropTypes.instanceOf(AnalyticsStore).isRequired,
  };

  downloadCSV = option => {
    const { analyticsStore } = this.props;
    const GDS_API_ENDPOINT = process.env.REACT_APP_GDS_API_ENDPOINT;
    const path = `${GDS_API_ENDPOINT}/v1/${option}/export`;
    const init = { headers: GdsApi.baseHeaders() };

    fetch(path, init)
      .then(response => response.blob())
      .then(response => {
        const fileName = fileNameOptions[option];
        // IE10+ has Blob, but not a[download]
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(response, fileName);
        } else {
          const a = document.createElement('a');
          const url = window.URL.createObjectURL(response);
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      })
      .catch(response => {
        GdsApi.handleRejectedFetch(response, path, init);
      });

    analyticsStore.track('Dashboard Interaction', { action: 'export' });
  };

  render() {
    const { gdsUiState } = this.props;
    return (
      <Modal onClose={() => gdsUiState.setExportGuestModalView(false)}>
        <H4 className={styles.heading}>Download Options</H4>
        <div className={styles.body}>
          <div className={styles.sectionContainer}>
            <div className={styles.leftSection}>
              <Icon name="checklist" size="md" />
              <div className={styles.textSection}>
                <Body1>Entire Guest List</Body1>
                <Caption className={styles.subText}>All guest info for all events</Caption>
              </div>
            </div>
            <DownloadButton onClick={() => this.downloadCSV('people')} />
          </div>
          <div className={styles.sectionContainer}>
            <div className={styles.leftSection}>
              <Icon name="email" size="md" />
              <div className={styles.textSection}>
                <Body1>Address Labels</Body1>
                <Caption className={styles.subText}>Guest info formatted for envelopes</Caption>
              </div>
            </div>
            <DownloadButton onClick={() => this.downloadCSV('addresslabel')} />
          </div>
          <div className={styles.sectionContainer}>
            <div className={styles.leftSection}>
              <Icon name="quick_reply" size="md" />
              <div className={styles.textSection}>
                <Body1>RSVP Responses</Body1>
                <Caption className={styles.subText}>All RSVP responses per guest</Caption>
              </div>
            </div>
            <DownloadButton onClick={() => this.downloadCSV('rsvp')} />
          </div>
        </div>
      </Modal>
    );
  }
}

export default ExportGuestListModal;
